// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rjn9O","col":"styles_col__1GJyn"};